// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-oClyWW","icon":"icon-drUzhK"};